/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * What the automation canvas offers, and how each kind of step looks
 * (design reference "Automations · Builder"): triggers in blue, logic in
 * purple and amber, actions in green. Only what the engine runs today is
 * available; the rest is listed as coming next.
 */

import {
  Braces,
  CalendarClock,
  CheckSquare,
  Clock,
  FilePlus2,
  Layers,
  Mail,
  PencilLine,
  Split,
  Trash2,
  Webhook,
  Zap,
} from "lucide-react";
import { v2Tones } from "styles/tokens/v2";

export const TONES = {
  trigger: v2Tones.info,
  condition: v2Tones.purple,
  wait: v2Tones.warning,
  action: v2Tones.success,
};

export const TRIGGERS = [
  { key: "create", label: "Record created", icon: Zap },
  { key: "update", label: "Record updated", icon: Zap },
  { key: "delete", label: "Record deleted", icon: Trash2 },
  { key: "schedule", label: "On a schedule", icon: CalendarClock, comingNext: true },
];

export const ACTIONS = [
  { type: "Update Field", label: "Update field", kindLabel: "Update field", icon: PencilLine },
  { type: "Create Task", label: "Create task", kindLabel: "Create task", icon: CheckSquare },
  { type: "Send Email", label: "Send email", kindLabel: "Send email", icon: Mail },
  { type: "Create Record", label: "Create record", kindLabel: "Create record", icon: FilePlus2 },
  { type: "Update Related Record", label: "Update related record", kindLabel: "Update related record", icon: Layers },
  { type: "Webhook", label: "Webhook", kindLabel: "Webhook", icon: Webhook },
];

export const actionMeta = (type) => ACTIONS.find((a) => a.type === type) || { type, label: "Choose an action", kindLabel: "Action", icon: Braces };

export const LOGIC = {
  condition: { label: "Condition", icon: Split },
  wait: { label: "Wait", icon: Clock },
};

/** The drag payload's MIME type, so foreign drags are ignored. */
export const DRAG_TYPE = "application/x-pearl-automation-step";
